import React from "react";
import "./label.css";

function Label({ digitCount, number1, number2, number3, number4, number5, number6 }) {
  if (!digitCount) return null;

  const numbers = [number1, number2, number3, number4, number5, number6].slice(
    0,
    digitCount,
  );

  return (
    <div>
      {numbers.map((number, i) => (
        <label key={i} className={number ? "number filled" : "number"}>
          {number}
        </label>
      ))}
    </div>
  );
}

export default Label;
